import React from "react";
import { Route, Routes } from "react-router-dom";

import AccountDeletionPage from "./pages/AccountDeletionPage/AccountDeletionPage";
import AboutPage from "./pages/EventsPage/AboutPage/AboutPage";
import EventPage from "./pages/EventsPage/EventsPage";
import EventsGallery from "./pages/EventsPage/EventsGallery/EventsGallery";
import MembershipsPage from "./pages/EventsPage/MembershipsPage/MembershipsPage";
import PropTechTimesPage from "./pages/EventsPage/PropTechTimesPage/PropTechTimesPage";
import ApexPage from "./pages/EventsPage/ApexPage/ApexPage";
import ArcePage from "./pages/EventsPage/ArcePage/ArcePage";
import AirexPage from "./pages/EventsPage/AirexPage/AirexPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";

const routes = (
  <Routes>
    <Route path="/" element={<EventPage />} />
    <Route path="/membership" element={<MembershipsPage />} />
    <Route path="/proptech-club/about" element={<AboutPage />} />
    <Route path="/gallery" element={<EventsGallery />} />
    <Route path="/proptech-club/memberships" element={<MembershipsPage />} />
    <Route path="/proptech-times" element={<PropTechTimesPage />} />
    <Route path="/events/apex" element={<ApexPage />} />
    <Route path="/events/ARCE" element={<ArcePage />} />
    <Route path="/events/airex" element={<AirexPage />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
    <Route path="/delete-account" element={<AccountDeletionPage />} />

    {/* <Route path="/*" element={<ErrorPage />} /> */}
  </Routes>
);

export default routes;
